var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center p-3"},[_c('router-link',{staticClass:"navbar-brand mx-0",attrs:{"to":{ name: 'guest.home' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }